'use client';

import { useQueryStates } from 'nuqs';
import { keyMaps } from './utils';

const useTenureFilterStore = () => {
  const [tenure, setTenure] = useQueryStates(keyMaps, {
    history: 'push',
  });

  return { ...tenure, setTenure };
};

type Tenure = 'Bostadsrätt' | 'Äganderätt';

type TenureFilterStore = ReturnType<typeof useTenureFilterStore>;

export { type Tenure, type TenureFilterStore, useTenureFilterStore };
